import { Box, TextField, Typography } from '@mui/material';
import { BaseButton } from 'components/atoms/Buttons';
import { Headings } from 'components/atoms/Typography';
import useTranslation from 'next-translate/useTranslation';
import { ChangeEvent, FormEvent, useEffect, useMemo, useState } from 'react';

interface IAddCommentProps {
    onChange?: (comment: string) => void;
    rows?: number;
    title?: string;
    initialValue?: string;
    multiline?: boolean;
    onDone?: (comment: string) => void;
    placeholder?: string;
}

const AddComment = ({
    onChange,
    rows = 4,
    title: _title,
    initialValue = '',
    multiline = false,
    onDone,
    placeholder,
}: IAddCommentProps) => {
    const [comment, setComment] = useState<string>(initialValue);
    const { t } = useTranslation('common');

    const title = useMemo(() => _title || t('addComment'), [_title, t]);

    useEffect(() => {
        if (onChange) onChange(comment);
    }, [comment]);

    const handleCommentChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        event.stopPropagation();
        setComment(event.target.value);
    };

    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();
        if (onDone) onDone(comment);
    };

    return (
        <Box>
            <Box mb={3}>
                <Headings.H2>{title}</Headings.H2>
            </Box>
            <form onSubmit={handleSubmit}>
                <Box mt={1} display="flex">
                    <Box pr={2} flex={1}>
                        <TextField
                            multiline={multiline}
                            rows={rows}
                            variant="outlined"
                            fullWidth
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#E1E1E1',
                                },
                                '& .MuiInputBase-input::placeholder': {
                                    fontStyle: 'italic',
                                },
                            }}
                            onChange={handleCommentChange}
                            value={comment}
                            onKeyDown={event => event.stopPropagation()}
                            placeholder={placeholder}
                        />
                    </Box>
                    {onDone && (
                        <BaseButton variant="primary" type="submit">
                            {t('goComment')}
                        </BaseButton>
                    )}
                </Box>
            </form>
        </Box>
    );
};

export default AddComment;
